import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const SeedingEvaluationReviewTagSchema = z
  .enum([
    'GOOD_CONTENT_QUALITY',
    'FOLLOWED_GUIDELINES',
    'GOOD_PRODUCT_DESCRIPTION',
    'FITS_BRAND_IMAGE',
    'GOOD_CAMPAIGN_PERFORMANCE',
    'FAST_FEEDBACK',
  ])
  .describe('SeedingEvaluationReviewTagSchema');

const GetSeedingEvaluationRequestSchema = z
  .object({
    seedingParticipationId: z.union([z.string(), z.number()]),
  })
  .describe('GetSeedingEvaluationRequestSchema');

export type GetSeedingEvaluationRequest = z.infer<typeof GetSeedingEvaluationRequestSchema>;

const GetSeedingEvaluationResponseDataSchema = z
  .object({
    rating: z.number(),
    reviewTags: z.array(SeedingEvaluationReviewTagSchema),
    reviewText: z.string().nullable().optional(),
  })
  .describe('GetSeedingEvaluationResponseDataSchema');

const GetSeedingEvaluationResponseSchema = createApiResponseSchema(
  GetSeedingEvaluationResponseDataSchema,
);

export type GetSeedingEvaluationResponse = z.infer<typeof GetSeedingEvaluationResponseSchema>;

/** GET `/v1/partner/seeding/evaluations/{seedingParticipationId}` — 시딩 캠페인 큐레이터 평가 조회 */
export const getSeedingEvaluation = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetSeedingEvaluationRequestSchema),
    async ({ seedingParticipationId }: GetSeedingEvaluationRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetSeedingEvaluationResponse>(
          partnerApiPath.getSeedingEvaluation(seedingParticipationId),
        ),
      ),
    validateApiResponse(GetSeedingEvaluationResponseSchema),
  ),
);
